import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "property" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "property-title" }, "基本资料", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_10 = { style: {"margin-left":"10px","margin-bottom":"10px"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "property-title" }, "往年经营信息", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("编辑非重要资料（免审核）")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("编辑完整资料（需审核）")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from "@element-plus/icons-vue";
import type {
  UploadFile,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

type FormInstance = InstanceType<typeof ElForm>;
interface CompanyBusinessInfo {
  deliverProjectNumber: number;
  deliverRoomNumber: number;
  hardRoomNumber: number;
  roughcastHouseNumber: number;
  communityProjectNumber: number;
  communityRoomNumber: number;
  annualTurnover: number;
  agentTotalCount: number;
  handbagAgentCount: number;
  lastYearProjectNumber: number;
  lastYearProjectSalesAmount: number;
}

interface Company {
  type: number;
  code: string;
  name: string;
  shortName: string;
  licenseNo: string;
  licenseFile: string;
  logo: string;
  brandLogo: string;
  brandBigLogo: string;
  brandName: string;
  developerName: string;
  contact: string;
  mobile: string;
  tel: string;
  companyAreaIds: string;
  companyAreaIdList: string[];
  companyFace: string;
  remark: string;
  website: string;
  province: string;
  city: string;
  area: string;
  address: string;
  corporateRepresentative: string;
  registeredFund: number;
  industry: string;
  businessCategory: string;
  teamSize: number;
  handbagCertificateLevel: string;
  storefront: string;
  licenseFileFullPath: string;
  logoFullPath: string;
  brandLogoFullPath: string;
  brandBigLogoFullPath: string;
  areaId: string;
  isEditAll: string;
  companyBusinessInfo: CompanyBusinessInfo;
  isPublic: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isDisabled = ref(true);
const isEditAll = ref(true);

const beforeUploadCheckEvent = (file: ElFile) => {
  let types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
  const isImage = types.includes(file.type);
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isImage) {
    ElMessage.error("上传的图片必须是JPG,GIF,BMP,PNG格式!");
  }
  if (!isLt2M) {
    ElMessage.error("上传的图片文件大小不能超过2MB!");
  }
  return isImage && isLt2M;
};

const handleEdit = () => {
  loadData("Y");
  isDisabled.value = false;
  isEditAll.value = false;
  bindData.isEditAll = "N";
};
const handleEditAll = () => {
  loadData("Y");
  isDisabled.value = false;
  isEditAll.value = true;
  bindData.isEditAll = "Y";
};
const handleSub = () => {
  loadData("N");
  isDisabled.value = true;
  isEditAll.value = true;
  bindData.isEditAll = "N";
};

const propertyFormRef = ref<FormInstance>();

const companyBusinessInfoValue: CompanyBusinessInfo = {
  deliverProjectNumber: 0,
  deliverRoomNumber: 0,
  hardRoomNumber: 0,
  roughcastHouseNumber: 0,
  communityProjectNumber: 0,
  communityRoomNumber: 0,
  annualTurnover: 0,
  agentTotalCount: 0,
  handbagAgentCount: 0,
  lastYearProjectNumber: 0,
  lastYearProjectSalesAmount: 0,
};

const company: Company = {
  type: 1,
  code: "",
  name: "",
  shortName: "",
  licenseNo: "",
  licenseFile: "",
  logo: "",
  brandLogo: "",
  brandBigLogo: "",
  brandName: "",
  developerName: "",
  contact: "",
  mobile: "",
  tel: "",
  companyAreaIds: "",
  companyAreaIdList: [],
  companyFace: "",
  remark: "",
  website: "",
  province: "",
  city: "",
  area: "",
  address: "",
  corporateRepresentative: "",
  registeredFund: 0,
  industry: "",
  businessCategory: "",
  teamSize: 0,
  handbagCertificateLevel: "",
  storefront: "",
  licenseFileFullPath: "",
  logoFullPath: "",
  brandLogoFullPath: "",
  brandBigLogoFullPath: "",
  areaId: "",
  isEditAll: "",
  companyBusinessInfo: companyBusinessInfoValue,
  isPublic: "",
};

const ustore = useStore();
const bindData = reactive({
  isEditAll: "N",
  propertyForm: company,
  companyAreaName: "",
  companyAreaOptions: [],
});

const handleLogoSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.propertyForm.logo = response.result;
  bindData.propertyForm.logoFullPath = URL.createObjectURL(file.raw);
};

const handleBrandLogoSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.propertyForm.brandLogo = response.result;
  bindData.propertyForm.brandLogoFullPath = URL.createObjectURL(file.raw);
};

const handleBrandBigLogoSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.propertyForm.brandBigLogo = response.result;
  bindData.propertyForm.brandBigLogoFullPath = URL.createObjectURL(file.raw);
};

const handleLicenseFileSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.propertyForm.licenseFile = response.result;
  bindData.propertyForm.licenseFileFullPath = URL.createObjectURL(file.raw);
};

const loadData = (isNotValid: string) => {
  companyAreaEvent();
  store.dispatch("companyModule/getCompany", { isNotValid: isNotValid }).then(
    (data) => {
      //成功
      bindData.propertyForm = data.result;
      bindAreaData(bindData.propertyForm.area);
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => {},
      });
    }
  );
};

const companyAreaEvent = () => {
  store.dispatch("companyModule/listCompanyArea").then(
    (data) => {
      //成功
      bindData.companyAreaOptions = data.result;
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => {},
      });
    }
  );
};
const saveCompanyAreaEvent = () => {
  store
    .dispatch("companyModule/saveCompanyArea", {companyAreaName : bindData.companyAreaName})
    .then(
      (data) => {
        ElMessage.success("成功.");
        companyAreaEvent();
        bindData.companyAreaName = "";
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

loadData("N");

const defaultValidate = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请填写企业编码"));
  } else {
    callback();
  }
};

const propertyRules = reactive({
  code: [{ required: true, validator: defaultValidate, trigger: "blur" }],
  name: [{ required: true, message: "请填写企业名称", trigger: "blur" }],
});

var chinaAreaDataOptions = ref("");
tool.getChinaAreaData(function (data) {
  chinaAreaDataOptions.value = data;
});

const selectAreaEvent = (value: any) => {
  if (value.length > 0) {
    var provinceId = value[0];
    var provinceName = tool.areaCodeToText.get(provinceId);
    if (provinceName != undefined) {
      bindData.propertyForm.province = provinceName;
    }
    var cityId = value[1];
    var cityName = tool.areaCodeToText.get(cityId);
    if (cityName != undefined) {
      bindData.propertyForm.city = cityName;
    }
    bindData.propertyForm.areaId = value[2];
    var areaName = tool.areaCodeToText.get(bindData.propertyForm.areaId);
    if (areaName != undefined) {
      bindData.propertyForm.area = areaName;
    }
  }
};

const bindAreaData = (areaName: string) => {
  if (areaName && areaName.length > 0) {
    var areaValue = tool.areaTextToCode.get(areaName);
    if (areaValue != undefined) {
      bindData.propertyForm.areaId = areaValue;
    }
  }
};

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      bindData.propertyForm.isEditAll = bindData.isEditAll;
      store.dispatch("companyModule/updateCompany", bindData.propertyForm).then(
        (data) => {
          //成功
          ElMessage.success("保存成功.");
          isDisabled.value = true;
          isEditAll.value = true;
          loadData("N");
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => {},
          });
        }
      );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log("exec...resetForm");
  if (!formEl) return;
  formEl.resetFields();
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_form, {
      model: _unref(bindData).propertyForm,
      ref_key: "propertyFormRef",
      ref: propertyFormRef,
      rules: _unref(propertyRules),
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "企业编码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).propertyForm.code) = $event)),
              readonly: true,
              "input-style": [{background:'#f5f7fa'},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "企业名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).propertyForm.name) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业简称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.shortName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).propertyForm.shortName) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业官网" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.website,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).propertyForm.website) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业地区" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              options: _unref(chinaAreaDataOptions),
              onChange: selectAreaEvent,
              disabled: isDisabled.value,
              modelValue: _unref(bindData).propertyForm.areaId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).propertyForm.areaId) = $event)),
              style: _normalizeStyle([{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'218px'}])
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", null, _toDisplayString(data.label), 1),
                (!node.isLeaf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(data.children.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["options", "disabled", "modelValue", "style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "详细地址" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              readonly: isDisabled.value,
              modelValue: _unref(bindData).propertyForm.address,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).propertyForm.address) = $event)),
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'218px'}]
            }, null, 8, ["readonly", "modelValue", "input-style"])
          ]),
          _: 1
        }),
        (isEditAll.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "企业信用编号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).propertyForm.licenseNo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).propertyForm.licenseNo) = $event)),
                  readonly: isDisabled.value,
                  "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
                  placeholder: "",
                  size: "default"
                }, null, 8, ["modelValue", "readonly", "input-style"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditAll.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "法人代表"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).propertyForm.corporateRepresentative,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).propertyForm.corporateRepresentative) = $event)),
                  readonly: isDisabled.value,
                  "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
                  placeholder: "",
                  size: "default"
                }, null, 8, ["modelValue", "readonly", "input-style"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditAll.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "注册资金"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).propertyForm.registeredFund,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).propertyForm.registeredFund) = $event)),
                  readonly: isDisabled.value,
                  "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
                  placeholder: "",
                  size: "default"
                }, null, 8, ["modelValue", "readonly", "input-style"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditAll.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "营业执照"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      class: _normalizeClass(["avatar-uploader", _unref(bindData).propertyForm.licenseFile && 'cur-uploader']),
                      action: _unref(tool).url('/personalCenter/uploadImageFile'),
                      "show-file-list": false,
                      "on-success": handleLicenseFileSuccess,
                      "before-upload": beforeUploadCheckEvent,
                      disabled: isDisabled.value
                    }, {
                      default: _withCtx(() => [
                        (_unref(bindData).propertyForm.licenseFile)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(bindData).propertyForm.licenseFileFullPath,
                              class: "avatar"
                            }, null, 8, _hoisted_4))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              class: "avatar-uploader-icon"
                            }, {
                              default: _withCtx(() => [
                                (isDisabled.value==false)
                                  ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["class", "action", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { label: "企业logo" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: _normalizeClass(["avatar-uploader", _unref(bindData).propertyForm.logo && 'cur-uploader']),
                  action: _unref(tool).url('/personalCenter/uploadImageFile'),
                  "show-file-list": false,
                  "on-success": handleLogoSuccess,
                  "before-upload": beforeUploadCheckEvent,
                  disabled: isDisabled.value
                }, {
                  default: _withCtx(() => [
                    (_unref(bindData).propertyForm.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(bindData).propertyForm.logoFullPath,
                          class: "avatar"
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            (isDisabled.value==false)
                              ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class", "action", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (isEditAll.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "所属地产品牌Logo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      class: _normalizeClass(["avatar-uploader", _unref(bindData).propertyForm.brandLogo && 'cur-uploader']),
                      action: _unref(tool).url('/personalCenter/uploadImageFile'),
                      "show-file-list": false,
                      "on-success": handleBrandLogoSuccess,
                      "before-upload": beforeUploadCheckEvent,
                      disabled: isDisabled.value
                    }, {
                      default: _withCtx(() => [
                        (_unref(bindData).propertyForm.brandLogo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(bindData).propertyForm.brandLogoFullPath,
                              class: "avatar"
                            }, null, 8, _hoisted_6))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              class: "avatar-uploader-icon"
                            }, {
                              default: _withCtx(() => [
                                (isDisabled.value==false)
                                  ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["class", "action", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditAll.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: "品牌形象海报"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      class: _normalizeClass(["avatar-uploader", _unref(bindData).propertyForm.brandBigLogo && 'cur-uploader']),
                      action: _unref(tool).url('/personalCenter/uploadImageFile'),
                      "show-file-list": false,
                      "on-success": handleBrandBigLogoSuccess,
                      "before-upload": beforeUploadCheckEvent,
                      disabled: isDisabled.value
                    }, {
                      default: _withCtx(() => [
                        (_unref(bindData).propertyForm.brandBigLogo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(bindData).propertyForm.brandBigLogoFullPath,
                              class: "avatar"
                            }, null, 8, _hoisted_7))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              class: "avatar-uploader-icon"
                            }, {
                              default: _withCtx(() => [
                                (isDisabled.value==false)
                                  ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["class", "action", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditAll.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: "所属地产品牌"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).propertyForm.brandName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).propertyForm.brandName) = $event)),
                  disabled: isDisabled.value,
                  "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
                  placeholder: "",
                  size: "default"
                }, null, 8, ["modelValue", "disabled", "input-style"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditAll.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 7,
              label: "开发商"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).propertyForm.developerName,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(bindData).propertyForm.developerName) = $event)),
                  readonly: isDisabled.value,
                  "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
                  placeholder: "",
                  size: "default"
                }, null, 8, ["modelValue", "readonly", "input-style"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { label: "联系人" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.contact,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(bindData).propertyForm.contact) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "联系人手机号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.mobile,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(bindData).propertyForm.mobile) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "固定电话" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.tel,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(bindData).propertyForm.tel) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "是否公开联系信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(bindData).propertyForm.isPublic,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(bindData).propertyForm.isPublic) = $event)),
              disabled: isDisabled.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "Y" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "N" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "公司介绍" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')}],
              modelValue: _unref(bindData).propertyForm.remark,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(bindData).propertyForm.remark) = $event)),
              type: "textarea",
              autosize: { minRows: 4, maxRows: 8 },
              autocomplete: "off"
            }, null, 8, ["readonly", "input-style", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "美居业务分区" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _unref(bindData).propertyForm.companyAreaIdList,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(bindData).propertyForm.companyAreaIdList) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).companyAreaOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      disabled: isDisabled.value,
                      key: item.id,
                      label: item.name
                    }, null, 8, ["disabled", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).companyAreaName,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(bindData).companyAreaName) = $event)),
                readonly: isDisabled.value,
                onBlur: saveCompanyAreaEvent,
                "input-style": "width:100px;float:right",
                placeholder: "自定义",
                size: "default"
              }, null, 8, ["modelValue", "readonly"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _hoisted_11,
    _createVNode(_component_el_form, { "label-width": "200px" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "预计交房项目数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: 
            _unref(bindData).propertyForm.companyBusinessInfo.deliverProjectNumber
          ,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((
            _unref(bindData).propertyForm.companyBusinessInfo.deliverProjectNumber
          ) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "预计交房套数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.companyBusinessInfo.deliverRoomNumber,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(bindData).propertyForm.companyBusinessInfo.deliverRoomNumber) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "预计精装房套数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).propertyForm.companyBusinessInfo.hardRoomNumber,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(bindData).propertyForm.companyBusinessInfo.hardRoomNumber) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "预计毛坯房套数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: 
            _unref(bindData).propertyForm.companyBusinessInfo.roughcastHouseNumber
          ,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((
            _unref(bindData).propertyForm.companyBusinessInfo.roughcastHouseNumber
          ) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "管辖的存量社区项目数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: 
            _unref(bindData).propertyForm.companyBusinessInfo.communityProjectNumber
          ,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((
            _unref(bindData).propertyForm.companyBusinessInfo.communityProjectNumber
          ) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "管辖的存量社区房屋套数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: 
            _unref(bindData).propertyForm.companyBusinessInfo.communityRoomNumber
          ,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((
            _unref(bindData).propertyForm.companyBusinessInfo.communityRoomNumber
          ) = $event)),
              readonly: isDisabled.value,
              "input-style": [{background:(isDisabled.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_container, { class: "property-btn" }, {
      default: _withCtx(() => [
        (isDisabled.value)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              type: "primary",
              onClick: handleEdit
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isDisabled.value)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              type: "danger",
              onClick: handleEditAll
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isDisabled.value)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 2,
              type: "primary",
              size: "large",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (submitForm(propertyFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isDisabled.value)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 3,
              type: "info",
              size: "large",
              onClick: handleSub
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})